<template>
  <nav class="navbar navbar-expand-lg sub-nav" id="addNav">
    <div class="container-fluid">

      <a id="back" class="navbar-link btn link-with-icon" @click="$emit('back')" @keyup.space="$emit('back')">
        <stihl-icon icon="chevron-left" />
        {{ $t('adm.button.back') }}
      </a>

      <div class="divider" />

      <div class="navbar-nav">
        <h3 class="title">{{ $t('adm.page.addUser.title') }}</h3>
      </div>

      <div class="collapse navbar-collapse d-flex justify-content-start" />

    </div>
  </nav>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import StihlIcon from '@/components/ui/StihlIcon.vue';

export default defineComponent({
  name: 'AddUserNavbar',
  components: { StihlIcon },
  emits: ['back'],
});
</script>

<style>
#addNav {
  --user-nav-height: 60px;
  height: var(--user-nav-height);
  flex-shrink: 0;
  border-bottom: 1px solid var(--grey-mid);
}

#addNav #back {
  padding-left: 2.5rem;
  padding-right: .5rem;
}

#addNav .container-fluid {
  --bs-gutter-x: 0;
  padding: var(--bs-gutter-y) var(--bs-gutter-x);
  gap: 1.88rem;
}

#addNav .divider {
  width: 1px;
  height: 47px;
  padding-top: 8px;
  background: var(--grey-mid);
}

#addNav .title {
  margin: 0;
}

</style>
